import { Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import FormSelectExpedidorRecebedor from '../../components/FormSelectExpedidorRecebedor';
import { Card, ColCard, Switch as SwitchAntd, Title } from '../../styles';
import { FormItem, GlobalStyle } from './styles';

export default function StepRecebedor({
  clienteRecebedor,
  setClienteRecebedor,
  clienteEnderecoDestinatario,
  hasContrato,
  isRecebedorIgualDestinatario,
  setIsRecebedorIgualDestinatario,
  setAlertMessageErrors,
}) {
  const changeIsRecebedorIgualDestinatario = value => {
    setIsRecebedorIgualDestinatario(value);

    if (value) {
      const newClientes = clienteRecebedor;
      const clientesAtualizados = [];
      clienteEnderecoDestinatario.forEach(cliente => {
        if (
          newClientes.filter(
            e => e.idClienteEndereco !== cliente.idClienteEndereco
          )
        ) {
          clientesAtualizados.push(cliente);
        }
      });

      setClienteRecebedor(clientesAtualizados);

      return;
    }

    const newClienteRecebedor = clienteRecebedor.filter(cliente => {
      for (let index = 0; index < clienteEnderecoDestinatario.length; index++) {
        const destinatario = clienteEnderecoDestinatario[index];

        if (destinatario.idClienteEndereco !== cliente.idClienteEndereco) {
          return false;
        }
      }
    });

    setClienteRecebedor(newClienteRecebedor);
  };

  const handleClienteRecebedor = () => {
    if (clienteEnderecoDestinatario) {
      clienteRecebedor.filter(cliente => {
        for (
          let index = 0;
          index < clienteEnderecoDestinatario.length;
          index++
        ) {
          const destinatario = clienteEnderecoDestinatario[index];
          if (
            destinatario.idClienteEndereco === cliente.idClienteEndereco &&
            clienteEnderecoDestinatario.length === clienteRecebedor.length
          ) {
            setIsRecebedorIgualDestinatario(true);
          } else {
            setIsRecebedorIgualDestinatario(false);
          }
        }
      });
    }
  };

  useEffect(() => {
    async function onChangeIgual() {
      if (clienteRecebedor.length === 0) {
        setIsRecebedorIgualDestinatario(false);
      }
      handleClienteRecebedor();
    }

    onChangeIgual();
  }, [isRecebedorIgualDestinatario, clienteRecebedor]);

  useEffect(() => {
    async function onInit() {
      handleClienteRecebedor();
    }

    onInit();
  }, []);

  return (
    <>
      <GlobalStyle />
      <Row style={{ height: '90%' }}>
        <ColCard span={12} className="height-71">
          <Card className="height-71">
            <Row>
              <Title>Recebedor</Title>

              <FormItem
                name="isRecebedorIgualDestinatario"
                label="Recebedor igual ao destinatário"
                labelAlign="right"
                className="mb-5"
              >
                <SwitchAntd
                  disabled={hasContrato}
                  defaultChecked
                  size="default"
                  checked={isRecebedorIgualDestinatario}
                  onChange={changeIsRecebedorIgualDestinatario}
                />
              </FormItem>
            </Row>
            <FormSelectExpedidorRecebedor
              label="Meus endereços"
              clienteExpedidorRecebedor={clienteRecebedor}
              setClienteExpedidorRecebedor={setClienteRecebedor}
              setAlertMessageErrors={setAlertMessageErrors}
              tipo="Recebedor"
            />
          </Card>
        </ColCard>
      </Row>
    </>
  );
}

StepRecebedor.propTypes = {
  clienteRecebedor: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteRecebedor: PropTypes.func.isRequired,
  clienteEnderecoDestinatario: PropTypes.arrayOf(PropTypes.any).isRequired,
  hasContrato: PropTypes.bool.isRequired,
  isRecebedorIgualDestinatario: PropTypes.bool.isRequired,
  setIsRecebedorIgualDestinatario: PropTypes.func.isRequired,
  setAlertMessageErrors: PropTypes.func.isRequired,
};
